import riveWasmUrl from '@rive-app/canvas/rive.wasm';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { DevTool } from 'components/dev-tool/DevTool';
import config from 'config/app-config';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { RuntimeLoader } from 'rive-react';

import { App } from './App';

const { authority, clientId } = config.keycloak;

let isRedirecting = false;

if (
  window.location.pathname === '/sign-up' ||
  window.location.pathname === '/sign-up/'
) {
  isRedirecting = true;
  const appUrl = encodeURIComponent(window.location.origin);

  window.location.href = `${authority}/protocol/openid-connect/registrations?client_id=${clientId}&redirect_uri=${appUrl}&response_mode=fragment&response_type=code&scope=openid`;
}

RuntimeLoader.setWasmUrl(riveWasmUrl);

const app = document.getElementById('root');

if (REACT_APP_STAGE !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./mocks/browser');
  const startMocks = () => {
    worker.start({
      onUnhandledRequest: 'bypass',
    });
  };

  const stopMocks = () => {
    worker.stop();
  };

  // @ts-expect-error this should be typed eventually
  window.mocks = {
    start: startMocks,
    stop: stopMocks,
  };
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(app!);

if (REACT_APP_STAGE === 'staging' && typeof REF !== 'undefined') {
  console.log('Deployment ref: ', REF);
}

root.render(
  isRedirecting ? (
    <Text variant="h5">Redirecting...</Text>
  ) : (
    <Router>
      <App />
      {REACT_APP_STAGE !== 'production' && <DevTool />}
    </Router>
  ),
);
